module.exports = __webpack_public_path__ + "img/download-on-google-play.ef602898.png";